import { computed, ref, watch, type Ref } from 'vue'

/** Mobile sheets are transient; their lifecycle must not overwrite the desktop preference. */
export function useResponsiveDrawer(isMobile: Ref<boolean>, desktopOpen: Ref<boolean>) {
  const mobileOpen = ref(false)
  watch(isMobile, () => { mobileOpen.value = false }, { flush: 'sync' })
  const drawerOpen = computed({
    get: () => isMobile.value ? mobileOpen.value : desktopOpen.value,
    set: (open: boolean) => {
      if (isMobile.value) mobileOpen.value = open
      else desktopOpen.value = open
    },
  })
  const onDrawerHide = () => { mobileOpen.value = false }
  return { drawerOpen, onDrawerHide }
}
